import { z } from 'zod';
import { createModel } from '../../common';

/** `price db model` */
export const PriceSchema = createModel({});

/** `price db model` */
export type Price = z.infer<typeof PriceSchema.model>;
export type PriceData = z.infer<typeof PriceSchema.data>;
export type PricePartial = z.infer<typeof PriceSchema.partial>;
